<template>
  <WidgetWrapper
    :title="title"
    :full-height="true"
    v-loading="fullscreenLoading"
  >
    <hr class="mb-2 -mt-2" />
    <SimpleTable
      :title="'Schedule Report'"
      :headers="headers"
      :items="items"
      :customizationPage="customizationPage"
      :options="options"
      @edit-row="edit"
      @remove-row="remove"
      @fetchData="fetchData"
    />
  </WidgetWrapper>
</template>

<script>
import SimpleTable from '@/components/dx/SimpleTable'
import formService from '@/mixins/FormService'
import formHelper from './form-helper'
import WidgetWrapper from '@/components/WidgetWrapper'

let service

export default {
  components: {
    SimpleTable,
    WidgetWrapper
  },

  mounted() {
    this.fetchData()
    service = new formService(this, formHelper)
  },
  data() {
    return {
      title: 'Scheduled Report - List',
      customizationPage: '/master/scheduled-report/create',
      apiRemove: this.$appInfo.api.mailList.delete,
      fullscreenLoading: false,
      dayOfWeek: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
      ],
      headers: [
        // { type: 'string', text: 'Company Name', value: 'Company' },
        { type: 'string', text: 'Schedule Name', value: 'SchedulerName' },
        { type: 'string', text: 'Report Name', value: 'ReportTitle' },
        { type: 'string', text: 'Send To', value: 'Email' },
        { type: 'string', text: 'Period', value: 'Period' },
        {
          type: 'string',
          text: 'Run Every',
          value: 'Day',
          width: 200,
          cellTemplate: 'displayDay'
        },
        { type: 'date', text: 'Next Schedule', value: 'NextRun' },
        { type: 'string', text: 'Created By', value: 'CreatedBy' },
        { type: 'string', text: 'Modified By', value: 'ModifiedBy' },
        {
          type: 'string',
          text: 'Action',
          value: 'Id',
          cellTemplate: 'commonAction',
          allowExporting: false
        }
      ],
      items: [],
      RecordsOnDuty: 0,
      options: {
        allowToAdd: false,
        allowToRefetch: true,
        allowExporting: true
      }
    }
  },
  methods: {
    edit(row) {
      var id = row.data.Id
      this.$router.push({
        name: `scheduled-report-edit`,
        params: { id: id }
      })
    },
    async remove(row) {
      this.$confirm(
        'This will permanently delete this record. Continue?',
        'Are you sure',
        {
          confirmButtonText: 'Delete',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(async () => {
          try {
            var id = row.data.Id
            await service.remove(id)

            this.fetchData()

            this.$message({
              type: 'success',
              message: 'Delete completed'
            })
          } catch (e) {
            this.$message.error(e)
            this.fullscreenLoading = false
            console.log(e)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          })
        })
    },

    async fetchData() {
      try {
        this.fullscreenLoading = true
        const res = await this.$axios.get(
          this.$appInfo.api.mailList.getAllAuthorize
        )
        let contentData = []
        res.data.map((data) => {
          let content = {}
          content['SchedulerName'] = data.SchedulerName
          content['ReportTitle'] = data.ReportTitle
          content['Email'] = data.Email
          content['Period'] = data.Period
          content['Day'] = data.DayStr
          content['NextRun'] = data.NextRun
          content['CreatedBy'] = data.CreatedBy
          content['ModifiedBy'] = data.ModifiedBy
          content['Id'] = data.Id

          contentData.push(content)
        })
        this.items = contentData
        this.fullscreenLoading = false
      } catch (e) {
        this.fullscreenLoading = false
        console.log(e)
      }
    }
  }
}
</script>
